<template>
  <div class="text-center">
    <v-snackbar
      v-model="get_interface.snackbar.active"
      :color="get_interface.snackbar.color"
      :timeout="2000"
      class="app_snackbar"
    >
      {{ get_interface.snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      get_interface: 'getInterface'
    })
  }
}
</script>

<style>
.app_snackbar {
  z-index: 99999 !important;
}

</style>
